import { Tooltip, TooltipProps, useTheme } from "@mui/material";
import * as React from "react";

/**
 * MUI `Tooltip` in Roboto's colours, forwarding its ref to the wrapped child.
 *
 * The ref is load-bearing wherever this wraps a Base UI trigger. `Popover`
 * renders its trigger through `BasePopover.Trigger`, which clones the element
 * with a merged ref and reads the resulting DOM node as the popup's anchor. A
 * plain function component drops that ref, so the popup still opens — props
 * spread through to the button underneath — but it anchors to nothing and
 * loses focus-return on close.
 */
export const RobotoTooltip = React.forwardRef<HTMLElement, TooltipProps>(
  function RobotoTooltip(props, ref) {
    const theme = useTheme();
    return (
      <Tooltip
        ref={ref}
        placement={props.placement || "bottom"}
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: theme.palette.secondary.main,
              "& .MuiTooltip-arrow": {
                color: theme.palette.secondary.main,
              },
            },
          },
        }}
        {...props}
      />
    );
  },
);
